import React, { Fragment } from 'react'
import { Slash as SlashIcon } from 'react-feather'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { Skeleton } from '@material-ui/lab'
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Typography,
} from '@material-ui/core'

import theme from 'theme'
import useStyles from './styles'

const BaseStatusCard = ({
  title = 'Desconhecido',
  subTitle = 'Status Desconhecido',
  Icon = SlashIcon,
  iconBgColor = theme.palette.secondary.main,
  variant = 'hexagon',
  selected = false,
  onClick = () => {},
  isLoading = false,
  titleProps = {},
  subTitleProps = {},
  titleResponse = false,
}) => {
  const classes = useStyles()

  return (
    <Fragment>
      {isLoading && !titleResponse ? (
        <Skeleton width="100%" height={80} variant="rect" />
      ) : (
        <Card
          className={clsx(classes.root, {
            [classes.cardSelected]: selected,
          })}
        >
          <CardActionArea
            onClick={onClick}
            disabled={isLoading}
            className={clsx(classes.cardActionArea, {
              [classes.isLoading]: isLoading,
            })}
          >
            <CardContent>
              <Box
                display="flex"
                alignItems="center"
                gridGap={theme.spacing(2)}
              >
                <Box
                  width="fit-content"
                  alignContent="center"
                  bgcolor={iconBgColor}
                  className={clsx({
                    [classes.hexagon]: variant === 'hexagon',
                    [classes.square]: variant === 'square',
                  })}
                >
                  <Icon color={theme.palette.common.white} />
                </Box>
                <Box className={classes.contentBox}>
                  {isLoading && titleResponse ? (
                    <Skeleton width="100%" height={32} variant="text" />
                  ) : (
                    <Typography variant="subtitle1" {...titleProps}>
                      {title}
                    </Typography>
                  )}
                  <Typography
                    variant="caption"
                    color="secondary"
                    className={classes.caption}
                    {...subTitleProps}
                  >
                    {subTitle}
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </CardActionArea>
        </Card>
      )}
    </Fragment>
  )
}

BaseStatusCard.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  subTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  Icon: PropTypes.elementType,
  iconBgColor: PropTypes.string,
  variant: PropTypes.oneOf(['hexagon', 'square']),
  selected: PropTypes.bool,
  onClick: PropTypes.func,
  isLoading: PropTypes.bool,
  titleProps: PropTypes.object,
  subTitleProps: PropTypes.object,
  titleResponse: PropTypes.bool,
}

export default BaseStatusCard
